import useToast from '../../components/Toast/useToast';

export const { toastSuccess, toastError, toastInfo, toastWarning } = useToast();
